// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56681440","667":"c9334b9d","977":"20a32ed2"}[chunkId] + ".chunk.js";
};